import React from 'react';
import type { TransformedReport } from '../types';

interface StrategySlideProps {
  data: TransformedReport;
  segmentIndex: number;
}

/**
 * StrategySlide - Slide 11: Honne -> Strategy -> Appeal direction (3 rows).
 */
const StrategySlide: React.FC<StrategySlideProps> = ({ data, segmentIndex }) => {
  const segments = data.segments ?? [];
  const seg = segments[segmentIndex];
  const strategies = data.appeal_strategies ?? [];

  if (!seg) return null;

  // Get strategies for this segment (or fallback to all)
  const segStrategies = strategies.filter((s) => s.segment_id === seg.segment_id);
  const effectiveStrategies = segStrategies.length > 0 ? segStrategies : strategies.slice(0, 3);

  // Build honne (insights) from emotion_map
  const honnes = [
    seg.emotion_map?.pain || '',
    seg.emotion_map?.barriers || '',
    seg.emotion_map?.purchase_drivers || '',
  ].filter(Boolean);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="slide-hdr">
        <p className="sl">Case 0{segmentIndex + 1} — Strategy</p>
        <h2>だから、こう伝える</h2>
        <p className="bt">3つのホンネに対して、それぞれ響く伝え方を設計しました</p>
      </div>

      <div className="strategy-rows">
        {effectiveStrategies.map((strat, i) => (
          <div key={i} className="strategy-row">
            {/* Honne */}
            <div
              className="card strategy-honne"
              style={{
                padding: 'clamp(10px, 1.4vmin, 20px)',
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <p className="sl" style={{ fontSize: 11, marginBottom: 4 }}>ホンネ 0{i + 1}</p>
              <p style={{ fontSize: 'clamp(13px, 1.8vmin, 16px)', fontWeight: 700, lineHeight: 1.4 }}>
                {honnes[i] || ''}
              </p>
            </div>

            {/* Arrow */}
            <div className="strategy-arrow">
              &#9654;
            </div>

            {/* Strategy box */}
            <div
              className="strategy-box"
              style={{
                background: '#1D1926',
                color: '#fff',
                borderRadius: 8,
                padding: 'clamp(10px, 1.4vmin, 20px)',
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: 'Inter, sans-serif', marginBottom: 4 }}>
                Strategy
              </p>
              <p style={{ fontSize: 'clamp(13px, 1.8vmin, 16px)', fontWeight: 700 }}>
                {strat.name || ''}
              </p>
            </div>

            {/* Direction description */}
            <div
              style={{
                flex: 1,
                padding: 'clamp(10px, 1.4vmin, 20px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <p style={{ fontSize: 'clamp(16px, 2.2vmin, 20px)', fontWeight: 700, marginBottom: 'clamp(4px, 0.6vmin, 8px)' }}>
                {strat.direction || ''}
              </p>
              {strat.copy_examples && strat.copy_examples[0] && (
                <p style={{ fontSize: 'clamp(12px, 1.6vmin, 15px)', color: 'rgba(29,25,38,0.55)', lineHeight: 1.7 }}>
                  {strat.copy_examples[0]}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrategySlide;
